import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import { Confirm, FileList } from './sharedComponents';
import * as fileActions from '../fileActions';
import { getCollection, getModel, ModelCollection } from '../store';
export default class JobCostFilesEdit extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.uploadFiles = this.uploadFiles.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
	}

	componentDidMount () {
		fileActions.fetchFilesForJob({ job: this.state.job });
	}
	UNSAFE_componentWillReceiveProps () {
		this.setState(this.getStateFromProps());
	}

	getStateFromProps () {
		const { routeParams, store } = componentServices;
		const jobKey = routeParams.jobkey;
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobKey});
		const state = _.assign({}, this.state);

		state.job = job;

		state.jobFiles = getCollection({ store, collection: ModelCollection.files}).filter(f => {
			return f.rootKey === job.key && (f.group === 'documents' || f.group === 'files');
		}).toArray();

		return state;
	}

	updateModel (updater, options) {
		this.props.updateModel(model => {
			updater(model);
		}, options);
	}

	uploadFiles (files, relatedType, relatedTypeKey) {
		const { job } = this.state;

		_.forEach(files, f => {
			fileActions.enqueueUpload({ rootKey: job.key, rootType: 'job', file: f, relatedType: relatedType, relatedTypeKey: relatedTypeKey });
		});
	}

	deleteFile (file) {
		const deleter = () => {
			fileActions.deleteFile({ file: file });
			actions.popModal();
		};
		const title = `Delete ${file.name}?`;

		actions.pushModal({
			component: <Confirm title={title} message="Are you sure you want to delete this file?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	render () {
		const { jobCost } = this.props;
		const { jobFiles } = this.state;
		const title = "Files";

		if (jobCost.currentChangeOrder) {
			const co = jobCost.currentChangeOrder;

			return <FileList key={co.key} title= { title } emptyTitle = { `No ${title}` } relatedType="change" relatedTypeKey={ co.key } list={ _.filter(jobFiles, { relatedType: 'change', relatedTypeKey: co.key }) } uploadFiles={ this.uploadFiles } deleteFile={ this.deleteFile } />;
		}
		else {
			return <FileList key={jobCost.key} title= { title } emptyTitle = { `No ${title}` } relatedType="jobcost" relatedTypeKey={ jobCost.key } list={ _.filter(jobFiles, { relatedType: 'jobcost', relatedTypeKey: jobCost.key }) } uploadFiles={ this.uploadFiles } deleteFile={ this.deleteFile } />;
		}
	}
}